import React from 'react'
import { Icon, IconProps } from '@chakra-ui/react'

const GunIcon = React.memo(({ color = '#D9D9D9', width = 18 }: IconProps) => {
  return (
    <Icon
      width={width}
      height={width}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 5C1.22386 5 1 5.22386 1 5.5V7.5C1 7.77614 1.22386 8 1.5 8H6.5V9.5C6.5 10.3284 7.17157 11 8 11H11.6L12.6758 13.6895C12.8615 14.1538 13.3617 14.4096 13.8468 14.2883L16.4143 13.6464C16.7184 13.5704 16.8784 13.2365 16.747 12.9518L14.4615 8H14.6529C15.1417 8 15.5589 7.64659 15.6393 7.1644L15.903 5.5822C15.9538 5.27743 15.7187 5 15.4098 5H1.5ZM10.9363 9.34085L11.2 10H8C7.72386 10 7.5 9.77614 7.5 9.5V8H10V8.69098L9.27639 9.05279L9.72361 9.94721L10.7236 9.44721L10.9363 9.34085Z"
        // @ts-expect-error assignable
        fill={color}
      />
    </Icon>
  )
})

export default GunIcon
